import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccentDanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4172 3H8.58281C8.48429 2.99992 8.38672 3.01926 8.29568 3.0569C8.20463 3.09454 8.12189 3.14975 8.05219 3.21938L3.21938 8.05219C3.14975 8.12189 3.09454 8.20463 3.0569 8.29568C3.01926 8.38672 2.99992 8.48429 3 8.58281V15.4172C2.99992 15.5157 3.01926 15.6133 3.0569 15.7043C3.09454 15.7954 3.14975 15.8781 3.21938 15.9478L8.05219 20.7806C8.12189 20.8503 8.20463 20.9055 8.29568 20.9431C8.38672 20.9807 8.48429 21.0001 8.58281 21H15.4172C15.5157 21.0001 15.6133 20.9807 15.7043 20.9431C15.7954 20.9055 15.8781 20.8503 15.9478 20.7806L20.7806 15.9478C20.8503 15.8781 20.9055 15.7954 20.9431 15.7043C20.9807 15.6133 21.0001 15.5157 21 15.4172V8.58281C21.0001 8.48429 20.9807 8.38672 20.9431 8.29568C20.9055 8.20463 20.8503 8.12189 20.7806 8.05219L15.9478 3.21938C15.8781 3.14975 15.7954 3.09454 15.7043 3.0569C15.6133 3.01926 15.5157 2.99992 15.4172 3Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 9L9 15",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 9L15 15",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAccentDanger;
